import { useSelector } from 'react-redux'
import { connectorSyncInsuranceListenersSelector } from '@redux/slices/connectorSlice'
import { Logger } from '@utils/logger'
import { SyncInsuranceAction } from '@typesApp/SyncListener'

type InvokerFunction = (action: SyncInsuranceAction) => Promise<void>

export const useInvokeSyncInsuranceListeners = (): InvokerFunction => {
  const listenerList = useSelector(connectorSyncInsuranceListenersSelector)

  const invokeListeners = (action: SyncInsuranceAction): Promise<void> => {
    return new Promise(resolve => {
      const listeners = listenerList?.listeners ?? []
      listeners.length &&
        Logger.debug('Invoking %s sync insurance listener(s) with action %s', listeners.length, action)

      try {
        listeners.forEach(handler => typeof handler === 'function' && handler(action))
      } catch (error) {
        Logger.warn('Error invoking sync insurance listener', error)
      } finally {
        resolve()
      }
    })
  }

  return invokeListeners
}
